module.exports = __webpack_public_path__ + "img/my.cab37729.svg";